import { BlogSectionType } from '../../../models/Content';

export const transformSectionYoutubeEmbed = (content: BlogSectionType) => {
    return {
        youtubeEmbedUrl: content.fields.youtubeEmbedUrl,
    };
};
